import { useParams, useSearchParams } from "react-router-dom";
import PreviewPlayer from "../../components/PreviewPlayer";

export default function PreviewFrame() {
  const { cid } = useParams();
  const [q] = useSearchParams();
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-10 flex h-14 items-center gap-2 border-b bg-background/90 px-4 backdrop-blur">
        <img src="/brand/dcbc_mark_red.png" alt="" className="h-7 w-auto" /><span className="font-display text-lg font-semibold">DCBC</span>
      </header>
      <main className="px-4 py-6 pb-12"><PreviewPlayer cid={cid} which={q.get("v") || "draft"} /></main>
    </div>
  );
}
